import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';
import { useProperty } from '@eti/providers';
import SaveTripButton from './SaveTripButton';
import SaveTripDrawer from './SaveTripDrawer';
import { useResultPageContext } from './contexts/ResultPageContext';

interface FloatingSaveTripButtonProps {
  setIsItineraryDrawerSelfTransferModalOpen: Dispatch<SetStateAction<boolean>>;
}

const FloatingSaveTripButton = ({
  setIsItineraryDrawerSelfTransferModalOpen,
}: FloatingSaveTripButtonProps) => {
  const { p } = useProperty();

  const shouldShowDrawerSaveTrip = p('Result.SaveTrip.Enabled');

  const [isSavedTripDrawerOpen, setIsSavedTripDrawerOpen] = useState(false);
  const { savedTrips, removeSavedTrip } = useResultPageContext();

  const openSavedTripDrawer = () => {
    sessionStorage.removeItem('haveMovedToTravelerDetails');
    setIsSavedTripDrawerOpen(true);
  };

  const closeSavedTripDrawer = () => {
    setIsSavedTripDrawerOpen(false);
  };

  return shouldShowDrawerSaveTrip ? (
    <div data-testid="floating-save-trip-button">
      <SaveTripButton onClick={openSavedTripDrawer} savedTripsLength={savedTrips?.length} />
      <SaveTripDrawer
        closeSavedTripDrawer={closeSavedTripDrawer}
        isSavedTripDrawerOpen={isSavedTripDrawerOpen}
        removeSavedTrip={removeSavedTrip}
        savedTrips={savedTrips}
        setIsItineraryDrawerSelfTransferModalOpen={setIsItineraryDrawerSelfTransferModalOpen}
      />
    </div>
  ) : null;
};

export default FloatingSaveTripButton;
